// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2-PJw","content":"LoadingAlert_content__7o_FP"};